const OperationInfoItem = ({children, title, infoText = null, infoJsx = null, bg = 'bg-body'}) => {
return (
    <div className="px-3 mb-3 position-relative">
            <div className={`${bg}  p-3 rounded`}>
            <div className="d-flex align-items-center mb-2">
                <div className="d-flex justify-content-between w-100">
                    <p className="h6 text-muted mb-0">{title}</p>
                    {infoJsx  && (
                    <div className="pb-1">
                        {infoJsx}
                    </div>)}
                </div>
            </div>
                {infoText && 
                (<div className="mb-2 fw-medium"> 
                    {infoText}
                </div>)}
                {children}
                
            </div>
        </div>
)
} 
export default OperationInfoItem; 